import React, { useReducer, useContext } from 'react'
import { initialState, reducer } from './reducer'

const StateContext = React.createContext()
const DisptacherContext = React.createContext()


export function useContextState() {
    const context = useContext(StateContext)

    if (!context) {
        throw Error('')
    }

    return context;
}

export function useContextDispatch() {
    const context = useContext(DisptacherContext)

    if (!context) {
        throw Error('')
    }

    return context;
}

// example of dispathcHandler : dispatchHandler(dispatch, GET_ITEM, {item: 'test'})
// Also write this code in the component for getting action types : const { GET_ITEM } = actionTypes

export function dispatchHandler(dispatch, type, payload) {
    return dispatch({
        type: type,
        payload: payload
    })
}

export function WbContextProvider({ children }) {
    const [state, dispatch] = useReducer(reducer, initialState)

    return (
        <StateContext.Provider value={state} >
            <DisptacherContext.Provider value={dispatch}>
                {children}
            </DisptacherContext.Provider>
        </StateContext.Provider>
    )
}
